const formValidationMixin = {
  methods: {
    validate(prop) {
      let forms = [];
      if (Array.isArray(this.$refs.form)) {
        forms = this.$refs.form;
      } else {
        forms.push(this.$refs.form);
      }

      const promises = forms.map(formC =>
        new Promise((resolve, reject) => {
          if (prop) {
            formC.validateField(prop, (errorMessage) => {
              if (!errorMessage) resolve();
              else reject(new Error(errorMessage));
            });
          } else {
            formC.validate((valid) => {
              if (valid) resolve();
              else reject(formC);
            });
          }
        }));
      return Promise.all(promises);
    },
  },
  mounted() {
    // Require updateForm to exist
    if (!this.$refs.form) throw new Error('formValidationMixin require a reference to `form`.');
  },
};

export default formValidationMixin;



// WEBPACK FOOTER //
// ./src/mixins/formValidationMixin.js